import { ComboItem, Response } from "../../../../model";
import { MedioPagoEditIn, MedioPagoEditOut, MedioPagoListOut, MonedaComboItem, MonedaEditIn, MonedaEditOut, MonedaListOut, SubMedioPagoListOut } from "../../../../model/cobranza";
import { LoteFacturacionEditIn, LoteFacturacionEditOut } from "../../../../model/cobranza/LoteFacturacionEditOut";
import { LoteFacturacionListOut } from "../../../../model/cobranza/LoteFacturacionListOut";
import { MedioPagoInfoOut } from "../../../../model/cobranza/MedioPagoInfoOut";
import { PrefacturacionListOut } from "../../../../model/cobranza/PrefacturacionListOut";
import { OperacionSistemaOrigen } from "../../../../model/operaciones/OperacionSistemaOrigen";
import ServiceBase from "../../../servicebase";
import { ControllerEntityService } from "./ControllerEntityService";

export class CobranzaService extends ServiceBase {
  private controller: string = 'cobranza';

  Moneda = () => new MonedaService(this.urlAPI, this.controller);

  MedioPago = () => new MedioPagoService(this.urlAPI, this.controller);

  LoteFacturacion = () => new LoteFacturacionService(this.urlAPI, this.controller);
}

export class MonedaService extends ControllerEntityService<MonedaEditOut, MonedaEditIn, MonedaListOut, MonedaComboItem, { id?: number, codigo?: string, nombre?: string }, {}> {
  constructor(urlApi: string, controller: string) {
    super(urlApi, controller, "Moneda");
  }
    
  byPais = (data: { idPais?: number, iso?: string }) => 
    this.GetFetch<Response<MonedaEditOut>>(`${this._controller}/${this._entity}/bypais`, data);
  
  cotizaciones = (data: { idmoneda?: number, desde?: string, origen?: number }) => 
    this.GetFetch<Response<any>>(`${this._controller}/${this._entity}/cotizaciones`, data);
  
}

export class MedioPagoService extends ControllerEntityService<MedioPagoEditOut, MedioPagoEditIn, MedioPagoListOut, ComboItem, { id?: number, includeId?: number, sociedad?: string, gateway?: string, nombre?: string, mostrarNombre?: string, sistemaOrigen?: string }, {}> {
  constructor(urlApi: string, controller: string) {
    super(urlApi, controller, "MedioPago");
  }

  submediopagos = {
    all: (data: {}) => this.GetFetch<Response<SubMedioPagoListOut[]>>(`${this._controller}/${this._entity}/submediopago/all`, data),
  }

  forCotizador = (data: { includeId?: number, idCotizador?: number, idOrigen?: number, idProveedor?: number, sistemaOrigen?: OperacionSistemaOrigen, cobroAutomatico?: boolean }) => 
    this.GetFetch<Response<MedioPagoInfoOut[]>>(`${this._controller}/${this._entity}/forcotizador`, data);
}

export class LoteFacturacionService extends ControllerEntityService<LoteFacturacionEditOut, LoteFacturacionEditIn, LoteFacturacionListOut, ComboItem, { id?: number, numeroOperacion?: string, creafechaDesde?: string, creafechaHasta?: string, generafechaDesde?: string, generafechaHasta?: string, aprobafechaDesde?: string, aprobafechaHasta?: string }, {}> {
  constructor(urlApi: string, controller: string) {
    super(urlApi, controller, "LoteFacturacion");
  }

  generar = (data: { id?: number }) => this.PostFetch<Response<number>>(`${this._controller}/${this._entity}/generar`, data);

  prefacturacion = (data: { pageIndex?: number, pageSize?: number, sort?: string, idLoteFacturacion?: number }) => this.GetFetch<Response<PrefacturacionListOut[]>>(`${this._controller}/${this._entity}/prefacturacion`, data);
 
  exportarDataManager = (data: { id?: number }) => this.PostFetch<Response<string>>(`${this._controller}/${this._entity}/exportar-datamanager`, data);

  aprobar = (data: { id?: number }) => this.PutFetch<Response<number>>(`${this._controller}/${this._entity}/aprobar`, data);
}
